import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Footer } from '../../containers/DefaultStyles/Shared';
import { PBVMFooter } from '../../components/Volunteer/Shared';
import ShareDrawer from '../../components/ShareDrawer';
import VolunteerStep3Form from '../../components/Volunteer/VolunteerStep3Form';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import {
    Container,
    VolunteerFormWrapper,
    FormHeader,
    Title,
    ParentOrg,
    Step,
    ScrollBody,
    volunteerMatchLogoURL
} from '../../components/Volunteer/Shared';

import { onGoToNextCard, setOverlayPartnerVisible } from '../Widget/actions';
import { onGoToStep, onSubmitVolunteerForm } from './actions';

import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

const VolunteerStep3 = props => (
    <TransitionContainer
        zIndex={4}
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <OverlayPartner
            logoIsSmall={false}
            transitionType="right-to-left"
            logo={volunteerMatchLogoURL}
            name={'About Volunteer Match'}
            description={
                "We believe everyone should have the chance to make a difference. That's why we make it easy for good people and good causes to connect. We've connected millions of people with a great place to volunteer and helped tens of thousands of organizations better leverage volunteers to create real impact."
            }
        />
        <ScrollBody>
            <WidgetHeader />
            <Container>
                <VolunteerFormWrapper>
                    <FormHeader>
                        <Title>Volunteer Signup</Title>
                        <Step>Step 2 of 2</Step>
                    </FormHeader>
                    <ParentOrg>{props.volunteerOpportunity.parentOrg.name}</ParentOrg>
                    <VolunteerStep3Form
                        volunteerOpportunity={props.volunteerOpportunity}
                        onBack={() => {
                            props.onGoToStep(3, 2);
                        }}
                        onSubmit={() => {
                            if (props.skipEndCard) {
                                props.handleSkippingEndCard(
                                    props.nextAction,
                                    props.cards,
                                    props.onGoToNextCard
                                );
                            }
                            props.onSubmitVolunteerForm(
                                props.volunteerOpportunity,
                                props.volunteerFormData,
                                props.apiRequestData,
                                props.actionCompletedTime(),
                                props.isMultiCard,
                                props.actionIdentifier,
                                props.skipEndCard
                            );
                        }}
                    />
                </VolunteerFormWrapper>
            </Container>
            <Footer>
                <ShareDrawer
                    fullwidth={true}
                    backgroundColor={'#fff'}
                    newsletterSignUpVisible={true}
                />
                <PBVMFooter onClick={e => props.setOverlayPartnerVisible(true, e, true)}>
                    {'Powered by VolunteerMatch'}
                </PBVMFooter>
            </Footer>
        </ScrollBody>
    </TransitionContainer>
);

VolunteerStep3.propTypes = {
    actionCompletedTime: PropTypes.func,
    actionIdentifier: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    cards: PropTypes.array.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    isBackTransition: PropTypes.bool.isRequired,
    isMultiCard: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    nextAction: PropTypes.object,
    skipEndCard: PropTypes.bool.isRequired,
    onGoToNextCard: PropTypes.func.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    onSubmitVolunteerForm: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    volunteerOpportunity: PropTypes.object.isRequired,
    volunteerFormData: PropTypes.object.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            actionCompletedTime: getActionCompletedTime(state, 'volunteer'),
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            cards: state.widget.cards,
            isBackTransition: state.volunteer.isBackTransition,
            isMultiCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isMobileResolution: state.widget.isMobileResolution,
            isSubmitting: state.volunteer.isSubmitting,
            nextAction,
            skipEndCard: state.widget.activeAction.skipEndCard,
            volunteerFormData: state.form.volunteer.values,
            volunteerOpportunity: state.volunteer.selectedVolunteerOpportunity
        };
    },
    {
        handleSkippingEndCard,
        onGoToNextCard,
        onGoToStep,
        onSubmitVolunteerForm,
        setOverlayPartnerVisible
    }
)(VolunteerStep3);
